import { render, staticRenderFns } from "./NotServiceable.vue?vue&type=template&id=76898052&scoped=true"
import script from "./NotServiceable.vue?vue&type=script&lang=js"
export * from "./NotServiceable.vue?vue&type=script&lang=js"
import style0 from "./NotServiceable.vue?vue&type=style&index=0&id=76898052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76898052",
  null
  
)

export default component.exports